import React, { Fragment, useState } from "react";
import __ from "lodash";
import {useQueryClient} from "react-query";
import { Button, Icon, IconButton, Link, makeStyles} from "@material-ui/core";
import { useTripLegs, useTrips } from "../../../services/trips";
import { ActionButton } from "./controls";
import { AirCargoIcon, UldContainerIcon, WeightKgIcon } from "../../../icons";
import useVTripAllotmentTotals from "../../../services/trips/useVTripAllotmentTotals";
import useVTripAllotments from "../../../services/trips/useVTripAllotments";
import useVTripLegUldStacks from "../../../services/trips/useVTripLegUldStacks";
import TripToolTipStyles from "../TripToolTipStyles";
import useColour from "../../../services/settings/useColour";
import { useAuth0 } from "@auth0/auth0-react";
import moment from "moment";
import { useAircraft, useAircraftMaxPayloads } from "../../../services/aircraft";

const AccessControl = require ("../../../AccessControl");

const CargoScreen = (props) => {
  const {tripData, eventBus, specialLoads, canViewDetails} = props; 

  const { user } = useAuth0();
  const canEdit = AccessControl.userHasAccess(user, ["Super Admin", "Admin", "Manage TRIPS"]);
  const canEditUld = AccessControl.userHasAccess(user, ["Super Admin", "Admin", "Manage TRIPS", "Manage ULD STOCK"]);

  const classes = makeStyles(TripToolTipStyles)();
  const queryClient = useQueryClient();
  const trip = useTrips({queryClient, extraKeys:[tripData.tripUuid]});
  const extraKeys = [tripData.tripUuid, tripData.uuid];
  const tripLeg = useTripLegs({queryClient, extraKeys});
  const allotmentTotals = useVTripAllotmentTotals({queryClient, extraKeys});
  const aircrafts = useAircraft({queryClient, extraKeys:[], useCache: true});
  const aircraftMaxPayloads = useAircraftMaxPayloads({queryClient, extraKeys:[tripLeg?.data?.aircraftId, tripLeg?.data?.originAirportCode, tripLeg?.data?.destinationAirportCode], useCache: true});
  const allotments = useVTripAllotments({queryClient, extraKeys});
  const uldStacks = useVTripLegUldStacks({queryClient, extraKeys});

  const [expanded, setExpanded] = useState({});
  const [stackExpanded, setStackExpanded] = useState({});
  const [slExpanded, setSlExpanded] = useState({});

  const totals = {
    maxPayload: 0,
    cargoAllotments: 0,
    uldStacks: 0,
    bookedCargo: 0,
    expectedPayload: 0,
    actualCargo: null
  }
  const allotmentRecords = [];

  if (tripLeg && tripLeg.data) {
    totals.actualCargo = tripLeg.data.actualCargo;
  }
  if (aircrafts && Array.isArray(aircrafts.data)) {
    const aircraft = __.find(aircrafts.data, {aircraftTailNumber: tripLeg?.data?.aircraftId});
    if (aircraft) {
      totals.maxPayload = aircraft.payload;
    }
  }  
  if (aircraftMaxPayloads && Array.isArray(aircraftMaxPayloads.data) && aircraftMaxPayloads.data.length > 0) { 
    if (__.has(aircraftMaxPayloads[0], 'maxPayload')) {
      totals.maxPayload = aircraftMaxPayloads.maxPayload;
    }
  }
  
  if (allotmentTotals && Array.isArray(allotmentTotals.data) && allotmentTotals.data.length > 0) {
    const newExpanded = {};
    allotmentTotals.data.forEach(record => {
      if (record.aoo !== "" && record.aod !== "") {
        allotmentRecords.push({...record, clientRecords: []});
        totals.cargoAllotments += record.totalAllotmentKg;
        newExpanded[`${record.aoo}-${record.aod}`] = false;
      }

      if (!totals.maxPayload) {
        totals.maxPayload = record.payload;
      }
    });
    if (Object.keys(expanded).length <1 && !__.isEqual(expanded, newExpanded)) setExpanded(newExpanded);
  }  

  if (allotments && Array.isArray(allotments.data) && allotments.data.length > 0) {
    allotments.data.forEach(record => {
      const allotmentRecord = __.find(allotmentRecords, {aoo: record.aoo, aod: record.aod});
      if (allotmentRecord) allotmentRecord.clientRecords.push(record);
    });
  }  

  if (uldStacks && Array.isArray(uldStacks.data) && uldStacks.data.length > 0) {
    const newExpanded = {};
    uldStacks.data.forEach(record => {
      totals.uldStacks += record.stackWeightKg;
      newExpanded[`${record.aoo}-${record.aod}`] = false;
    });
    if (Object.keys(stackExpanded).length <1 && !__.isEqual(stackExpanded, newExpanded)) setStackExpanded(newExpanded);
  }  

  totals['expectedPayload'] = totals['cargoAllotments'] + totals['uldStacks'];

  const toggleCargoExpanded = (props) => {
    const newExpanded = {...expanded};
    newExpanded[`${props.aoo}-${props.aod}`] = !expanded[`${props.aoo}-${props.aod}`];
    setExpanded(newExpanded);
  }

  const toggleStackExpanded = (props) => {
    const newExpanded = {...stackExpanded};
    newExpanded[`${props.aoo}-${props.aod}`] = !stackExpanded[`${props.aoo}-${props.aod}`];
    setStackExpanded(newExpanded);
  }

  const toggleSpecialLoadExpanded = (props) => {
    const newExpanded = {...slExpanded};
    newExpanded[`${props.name}`] = !slExpanded[`${props.name}`];
    setSlExpanded(newExpanded);
  }

  const WeightLine = (props) => {
    const backgroundColor = useColour({code: 'CARGO TOTALS BACKGROUND', status: props.status||"DEFAULT"});
    const color = useColour({code: 'CARGO TOTALS TEXT', status: props.status||"DEFAULT"});
    return (
      <div className={classes.weightLine} style={{backgroundColor, color}}>
        <div style={{fontWeight: "700", display: "inline-block", width: "calc(75% - 5px)", paddingLeft: 5}}>{props.label}</div>
        <div style={{display: "inline-block", textAlign: "right", width: "calc(25% - 5px)"}}>{props.weight === null?'--':props.weight === 0?'NIL':props.weight}</div>
      </div>
    );
  }

  const WeightLineTotal = (props) => {
    return (
      <div className={classes.WeightLineTotal}>
        <div style={{display: "inline-block", width: "calc(75% - 5px)", paddingRight: 5, textAlign: "right"}}>{props.label}</div>
        <div style={{display: "inline-block", textAlign: "right", width: "calc(25% - 5px)"}}>{props.weight}</div>
      </div>
    );
  }

  const CargoClientHeader = (props) => {
    return (
      <div className={classes.cargoClientTableHeader}>
        <div style={{fontWeight: "700", display: "inline-block", width: "calc(75% - 5px)", paddingLeft: 5}}>Client</div>
        <div style={{display: "inline-block", textAlign: "right", width: "calc(25% - 10px)"}}>Allotment</div>
      </div>
    );
  }

  const CargoClient = (props) => {
    return (
      <div className={classes.cargoClientRow}>
        <div style={{fontWeight: "700", display: "inline-block", width: "calc(75% - 5px)", paddingLeft: 5}}>{props.companyName}</div>
        <div style={{display: "inline-block", textAlign: "right", width: "calc(25% - 10px)"}}>{props.allotmentKg}</div>
      </div>
    );
  }

  const CargoRow = (props) => {
    const open = expanded[`${props.aoo}-${props.aod}`];
    return (
      <div>
        <div className={classes.cargoRow}>
          {canViewDetails === true?
            <div style={{display: "inline-block", width: 48, minWidth: 48}}><IconButton style={{padding: 6}} onClick={()=>toggleCargoExpanded(props)}><Icon style={{transform: open?"rotate(90deg)":"none"}}>chevron_right</Icon></IconButton></div>
          :
          <div style={{display: "inline-block", width: 48, minWidth: 48, height: 48, verticalAlign: "middle"}}></div>
        }
          <div style={{fontWeight: "700", display: "inline-block", width: "60%"}}>{props.aoo} - {props.aod}</div>
          <div style={{display: "inline-block", textAlign: "right", width: "calc(40% - 60px)"}}>{props.totalAllotmentKg}</div>
        </div>
        {open? 
          <div>
            <CargoClientHeader />
            {
              props.clientRecords.map(record => (
                <CargoClient 
                  companyName={record.companyName}
                  aoo={record.aoo} 
                  aod={record.aod} 
                  allotmentKg={record.allotmentKg}                      />
              ))
            }
          </div>
        :null}
      </div>
    );
  }
  const CargoHeader = (props) => {
    return (
      <div className={classes.cargoTableHeader}>
        <div style={{display: "inline-block", width: 48, minWidth: 48}}></div>
        <div style={{fontWeight: "700", display: "inline-block", width: "60%"}}>Unloading Point</div>
        <div style={{fontWeight: "700", display: "inline-block", textAlign: "right", width: "calc(40% - 60px)"}}>Total Kg</div>
      </div>
    );
  }

  const StackULDHeader = (props) => {
    return (
      <div className={classes.cargoClientTableHeader}>
        <div style={{fontWeight: "700", display: "inline-block", width: "calc(100% - 198px", paddingLeft: 5}}>ULD Type</div>
        <div style={{display: "inline-block", textAlign: "right", width: 60}}>Quantity</div>
      </div>
    );
  }

  const StackULD = (props) => {
    return (
      <div className={classes.cargoClientRow}>
        <div style={{fontWeight: "700", display: "inline-block", width: "calc(100% - 198px", paddingLeft: 5}}>{props.uldType}</div>
        <div style={{display: "inline-block", textAlign: "right", width: 60}}>{props.quantity}</div>
      </div>
    );
  }

  const StackEquipmentHeader = (props) => {
    return (
      <div className={classes.cargoClientTableHeader}>
        <div style={{fontWeight: "700", display: "inline-block", width: "calc(100% - 198px", paddingLeft: 5}}>Equipment Type</div>
        <div style={{display: "inline-block", textAlign: "right", width: 60}}>&nbsp;</div>
        <div style={{display: "inline-block", textAlign: "right", width: 60}}>Quantity</div>
      </div>
    );
  }

  const StackEquipment = (props) => {
    return (
      <div className={classes.cargoClientRow}>
        <div style={{fontWeight: "700", display: "inline-block", width: "calc(100% - 198px", paddingLeft: 5}}>{props.equipmentName || props.equipmentType}</div>
        <div style={{display: "inline-block", textAlign: "right", width: 60}}>&nbsp;</div>
        <div style={{display: "inline-block", textAlign: "right", width: 60}}>{props.quantity}</div>
      </div>
    );
  }

  const StackRow = (props) => {
    const open = stackExpanded[`${props.aoo}-${props.aod}`];
    let uldCount = 0;
    let equipmentCount = 0;
    props.uldStack.forEach(record => {uldCount += record.quantity});
    props.equipment.forEach(record => {equipmentCount += record.quantity});
    return (
      <div>
        <div className={classes.cargoRow}>
          <div style={{display: "inline-block", width: 48, minWidth: 48}}><IconButton style={{padding: 6}} onClick={()=>toggleStackExpanded(props)}><Icon style={{transform: open?"rotate(90deg)":"none"}}>chevron_right</Icon></IconButton></div>
          <div style={{fontWeight: "700", display: "inline-block", width: "calc(100% - 240px"}}>{props.aoo} - {props.aod}</div>
          <div style={{display: "inline-block", textAlign: "right", width: 60}}>{uldCount}</div>
          <div style={{display: "inline-block", textAlign: "right", width: 60}}>{equipmentCount}</div>
          <div style={{display: "inline-block", textAlign: "right", width: 60}}>{props.stackWeightKg}</div>
        </div>
        {open? 
          <div>
            {props.uldStack && props.uldStack.length > 0?
              <>
                <StackULDHeader />
                {
                  props.uldStack.map(record => (
                    <StackULD 
                      uldType={record.uldType}
                      quantity={record.quantity}                      />
                  ))
                }
              </>
            : null}
            {props.equipment && props.equipment.length > 0?
              <>
                <StackEquipmentHeader />
                {
                  props.equipment.map(record => (
                    <StackEquipment
                      equipmentType={record.equipmentType}
                      equipmentName={record.equipmentName}
                      quantity={record.quantity}                      
                    />
                  ))
                }
              </>
            : null}
          </div>
        :null}
      </div>
    );
  }
  const StackHeader = (props) => {
    return (
      <div className={classes.cargoTableHeader}>
        <div style={{display: "inline-block", width: 48, minWidth: 48}}></div>
        <div style={{fontWeight: "700", display: "inline-block", width: "calc(100% - 240px"}}>Unloading Point</div>
        <div style={{fontWeight: "700", display: "inline-block", width: 60, textAlign: "right"}}>ULD's</div>
        <div style={{fontWeight: "700", display: "inline-block", width: 60, textAlign: "right"}}>Equipment</div>
        <div style={{fontWeight: "700", display: "inline-block", textAlign: "right", width: 60}}>Total Kg</div>
      </div>
    );
  }

  const SpecialLoadHeader = (props) => {
    return (
      <div className={classes.cargoTableHeader}>
        <div style={{display: "inline-block", width: 48, minWidth: 48}}></div>
        <div style={{fontWeight: "700", display: "inline-block", width: "60%"}}>Category</div>
        <div style={{fontWeight: "700", display: "inline-block", textAlign: "right", width: "calc(40% - 60px)"}}>Qty</div>
      </div>
    );
  }

  const SpecialLoadRow = (props) => {
    const open = slExpanded[`${props.name}`];
    return (
      <div>
        <div className={classes.cargoRow}>
          <div style={{display: "inline-block", width: 48, minWidth: 48}}><IconButton style={{padding: 6}} onClick={()=>toggleSpecialLoadExpanded(props)}><Icon style={{transform: open?"rotate(90deg)":"none"}}>chevron_right</Icon></IconButton></div>
          <div style={{fontWeight: "700", display: "inline-block", width: "60%"}}>{props.name}</div>
          <div style={{display: "inline-block", textAlign: "right", width: "calc(40% - 60px)"}}>{props.count}</div>
        </div>
        {open? 
          <div>
            {props.children}
          </div>
        :null}
      </div>
    );
  }

  const SlrRowHeader = (props) => {
    return (
      <div className={classes.cargoClientTableHeader}>
        <div style={{fontWeight: "700", display: "inline-block", width: "calc(75% - 5px)", paddingLeft: 5}}>Reference</div>
        <div style={{display: "inline-block", textAlign: "right", width: "calc(25% - 10px)"}}>Weight (kg)</div>
      </div>
    );
  }

  const SlrRow = (props) => {
    const {bookingUuid, slrReference, specialLoadDescription, expectedWeightKg} = props.data;

    const handleOpenBooking = () => {
      eventBus.trigger("ViewBooking.open",{open: true, bookingUuid});
    }

    return (
      <div className={classes.cargoClientRow}>
        <div style={{fontWeight: "700", display: "inline-block", width: "calc(100% - 75px", paddingLeft: 5}}><Link component={Button} variant="link" onClick={handleOpenBooking} style={{padding: 0, fontSize: 10, textDecoration: "underline", color: "blue"}}>{slrReference}</Link></div>
        <div style={{display: "inline-block", textAlign: "right", width: 60}}>{expectedWeightKg}</div>
        <div style={{display: "block", textAlign: "left", width: "100%", paddingLeft: 5, paddingRight: 5, overflow: "wrap" }}>{specialLoadDescription}</div>
      </div>
    )
  }

  const SpecialLoads = (props) => {
    const {slr, dgr, temp, avi} = specialLoads;

    if (slr.count === 0 && dgr.count === 0 && temp.count === 0 && avi.count === 0) return null;
    const categories = [];
    if (slr.count) {
      categories.push(
        <SpecialLoadRow count={slr.count} name="Special Loads">
          <SlrRowHeader />
          {slr.records.map(record => (
            <SlrRow data={record}></SlrRow>
          ))}
        </SpecialLoadRow>
      );
    }
    if (dgr.count) {
      categories.push(
        <SpecialLoadRow count={slr.count} name="Dangerous Goods">

        </SpecialLoadRow>
      );
    }
    if (dgr.count) {
      categories.push(
        <SpecialLoadRow count={slr.count} name="Temperature Controlled">

        </SpecialLoadRow>
      );
    }
    if (dgr.count) {
      categories.push(
        <SpecialLoadRow count={slr.count} name="Live Animals">

        </SpecialLoadRow>
      );
    }

    return (
      <div style={{width: "100%", height: "100%", display: "table", borderCollapse:"collapse"}}>
        <div style={{width: "100%", paddingBottom: 5}}>
          <div style={{display: "inline-block"}}><AirCargoIcon style={{position: "relative", top: 2}}/></div>
          <div style={{display: "inline-block", textAlign: "left", fontSize: 20, fontWeight: "bold", marginLeft: 3}}>Special Cargo Details</div>
        </div>  
        <SpecialLoadHeader/>
        {categories.map(row => row)}
      </div>  
    )

  }

  if (!trip.data || !allotmentTotals.data || !allotments.data || !uldStacks.data) return null;
    return (<div style={{width: "100%", height: "100%", display: "table", borderCollapse:"collapse"}}>
    <div style={{width: "100%", paddingBottom: 5}}>
      <div style={{display: "inline-block"}}><AirCargoIcon style={{position: "relative", top: 2}}/></div>
      <div style={{display: "inline-block", textAlign: "left", fontSize: 20, fontWeight: "bold", marginLeft: 3}}>Cargo Details</div>
      {canEdit?
        <div style={{display: "inline-block", float:"right", textAlign: "right"}}>
          <ActionButton 
            variant="outlined" 
            startIcon={<Icon>edit</Icon>}
            onClick={()=>{
              const tripUuid = trip.data[0].tripUuid;
              const tripRoute = trip.data[0].tripRoute;
              eventBus.trigger("RouteView.TimeWindow.TripAction.editCargo", {canEdit, tripUuid, tripRoute});
            }}
          >
            Edit
          </ActionButton>
        </div>
      :
        <></>
      }
    </div>
    {CargoRow && Array.isArray(CargoRow) && CargoRow.length === 0?
      <div style={{fontSize: 16, fontWeight: "bold", padding: 10, textAlign: "center", border: "1px solid #ffffff", color: "#000000", backgroundColor: "#dddddd"}}>
        No Cargo allocated to this flight
      </div>    
    :
      <>
        <div style={{width: "100%"}}>
          <CargoHeader />
        </div>
        <div>
          {allotmentRecords.map(record => {
            return (
              <CargoRow 
                aoo={record.aoo} 
                aod={record.aod} 
                totalAllotmentKg={record.totalAllotmentKg}
                clientRecords={record.clientRecords}
              />
            );
          })}
        </div>
        <div style={{height: 15}}></div>
        <div style={{width: "100%", paddingBottom: 5}}>
          <div style={{display: "inline-block"}}><UldContainerIcon style={{position: "relative", top: 2}}/></div>
          <div style={{display: "inline-block", textAlign: "left", fontSize: 20, fontWeight: "bold", marginLeft: 3}}>Pallet Stack(s)</div>
          {canEdit || canEditUld?
            <div style={{display: "inline-block", float:"right", textAlign: "right"}}>
              <ActionButton 
                variant="outlined" 
                startIcon={<Icon>edit</Icon>}
                onClick={()=>{
                  const tripUuid = trip.data[0].tripUuid;
                  const tripRoute = trip.data[0].tripRoute;
                  eventBus.trigger("RouteView.TimeWindow.TripAction.editUldStack",{canEdit: canEdit||canEditUld, tripUuid, tripRoute});
                }}
              >
                Edit
              </ActionButton>
            </div>
          :
            <></>
          }
        </div>
      </>
    } 
    {uldStacks.data && Array.isArray(uldStacks.data) && uldStacks.data.length === 0?
      <div style={{fontSize: 16, fontWeight: "bold", padding: 10, textAlign: "center", border: "1px solid #ffffff", color: "#000000", backgroundColor: "#dddddd"}}>
        No Stacks allocated to this flight
      </div>    
    :
      <>
        <div style={{width: "100%"}}>
          <StackHeader />
        </div>
        <div>
          {uldStacks.data.map(record => {
            return (
              <StackRow 
                aoo={record.aoo} 
                aod={record.aod} 
                stackWeightKg={record.stackWeightKg}
                uldStack={record.uldStack||[]}
                equipment={record.equipment||[]}
              />
            );
          })}
        </div>
      </>
    }
    <div style={{height: 15}}></div>
    {specialLoads?
      <SpecialLoads data={specialLoads}/> 
    :<></>
    }
    <div style={{height: 15}}></div>
    <div style={{display: "table-row", verticalAlign: "bottom", height: "1px"}}>
      <div style={{width: "100%", paddingBottom: 5}}>
        <div style={{display: "inline-block"}}><WeightKgIcon style={{position: "relative", top: 2}}/></div>
        <div style={{display: "inline-block", textAlign: "left", fontSize: 20, fontWeight: "bold", marginLeft: 3}}>Payload Info</div>
        {canEdit ?
          <div style={{display: "inline-block", float:"right", textAlign: "right"}}>
            <ActionButton 
              variant="outlined" 
              startIcon={<Icon>edit</Icon>}
              onClick={()=>{
                eventBus.trigger("RouteView.TimeWindow.TripAction.editPayload",{canEdit, title: `Actual Payload for ${tripData.airlineCode}${tripData.flightNo} ${moment.utc(tripData.scheduledDepartureTimeUTC).format("D MMM")}`, record: {tripLegUuid: tripData.uuid, actualCargo: totals.actualCargo, maxPayload: totals.maxPayload}});
              }}
            >
              Edit
            </ActionButton>          
          </div>
        :
          <></>
        }
      </div>
      <div style={{width: "calc(100% - 2px)", border: "1px solid #ffffff", fontSize: 14, backgroundColor: ""}}>
        <WeightLine status={totals.cargoAllotments === 0?'ERROR':'DEFAULT'} label="Cargo Allotments" weight={totals.cargoAllotments}/>
        <WeightLine status="DEFAULT" label="Pallet Stacks" weight={totals.uldStacks}/>
        <WeightLineTotal label="Total" weight={totals.expectedPayload}/>
        <WeightLine status={totals.actualCargo === null?'ERROR':Math.abs(100 - (totals.actualCargo / (totals.expectedPayload)) > 10) ?'WARNING':'DEFAULT'} label="Actual Payload" weight={totals.actualCargo}/>
        {/* <WeightLine status={totals.actualCargo > totals.maxPayload?'ERROR':(totals.expectedPayload) > totals.maxPayload ?'ERROR':'DEFAULT'} label="Maximum Payload" weight={totals.maxPayload}/> */}
      </div>
    </div>
  </div>); 
}

export default CargoScreen;